import { service } from "@server/client";
import type {
  GetCartQuery,
  GetCartQueryVariables,
  GetCheckoutQueryVariables,
} from "@server/gql/graphql";
import { getCartQuery } from "@server/queries/cart";

export const getCart = async (variables: GetCheckoutQueryVariables) => {
  try {
    const response = await service<GetCartQuery, GetCartQueryVariables>({
      query: getCartQuery,
      variables,
    });

    return response.cart;
  } catch (error: Error | unknown) {
    console.error("Error in getCart", error);
    throw error;
  }
};
